<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-16 12:02:05
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-17 15:44:46
 * @FilePath: \zhucai_user\src\pages\member\child\info.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div v-loading="isloading" class="my-container">
    <div class="my-title">我的订单</div>
    <div class="my-content">
      <h1 class="statusName">{{ info.StatusTxt }}</h1>
      <div class="my-info">
        <div class="my-info-item">
          <div class="my-info-item-title">订单编号：</div>
          <div class="my-info-item-content">{{ info.OrdersNo }}</div>
        </div>
        <div class="my-info-item">
          <div class="my-info-item-title">订单时间：</div>
          <div class="my-info-item-content">{{ info.AddTime }}</div>
        </div>
        <div class="my-info-item">
          <div class="my-info-item-title">订单类型：</div>
          <div class="my-info-item-content">{{ info.RelatedTypeTxt }}</div>
        </div>
      </div>
      <div class="mt50 mb20">
        <h2 class="title">商品信息</h2>
        <el-table highlight-current-row
    @current-change="gotoDetail"  :data="info.Items">
          <el-table-column prop="RelatedName" label="商品名称">
          </el-table-column>
          <el-table-column
            prop="TypeName"
            label="类型"
            width="300"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="Price" label="价格" width="300" align="center">
            <template slot-scope="scope">
              <span class="Amount">{{
                scope.row.Price ? "¥ " + scope.row.Price : ""
              }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="my-info">
        <div class="my-info-item">
          <div class="my-info-item-title">下单方式：</div>
          <div class="my-info-item-content">{{ info.SourceTxt }}</div>
        </div>
        <!-- <div class="my-info-item">
          <div class="my-info-item-title">下单账号：</div>
          <div class="my-info-item-content">{{ info.AddTime }}</div>
        </div> -->
        <div class="my-info-item">
          <div class="my-info-item-title">支付方式：</div>
          <div class="my-info-item-content">{{ info.PayWayTxt }}</div>
        </div>
        <div class="my-info-item">
          <div class="my-info-item-title">支付时间：</div>
          <div class="my-info-item-content">{{ info.PayTime }}</div>
        </div>
        <div class="my-info-item">
          <div class="my-info-item-title bold">订单金额：</div>
          <div class="my-info-item-content Amount b600">
            {{ info.Amount ? "¥ " + info.Amount : "" }}
          </div>
        </div>
        <div class="my-info-item mt50">
          <el-button class="submit-btn" @click="back"> 返回 </el-button>
          <el-button
            v-if="info.StatusID == 0"
            class="submit-btn"
            @click="toPay"
          >
            付款
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetMyOrdersDetail } from "@/api/member";

/* eslint-disable */
export default {
  name: "orderDetail",
  data() {
    return {
      isloading: true,
      info: {
        Items: [],
      },
    };
  },

  mounted() {
    this.getInfo();
  },

  methods: {
    gotoDetail(item) {
      console.log('item',item)
      if (item.TypeID == "1") {
        this.$router.push({
          path: "/courseDetail",
          query: {
            CourseID: item.RelatedID,
          },
        });
      } else if (item.TypeID == "2") {
        this.$router.push({
          path: "/materialDetail",
          query: {
            MaterialID: item.RelatedID,
          },
        });
      } else if (item.TypeID == "3") {
        this.$router.push({
          path: "/qbankDetail",
          query: {
            ExerciseID: item.RelatedID,
          },
        });
      } else if (item.TypeID == "4") {
        this.$router.push({
          path: "/apipcEnrollDetail",
          query: {
            SubjectID: item.RelatedID,
          },
        });
      }
    },
    close() {
      this.getInfo();
    },
    back() {
      this.$router.push({ path: "/member/order" });
    },
    toPay(data) {
      this.$router.push({
        path: "/confirmOrder",
        query: {
          OrdersID: this.info.OrdersID,
        },
      });
    },
    getInfo() {
      this.isloading = true;
      GetMyOrdersDetail({
        OrdersID: this.$route.query.OrdersID,
      })
        .then((res) => {
          this.isloading = false;
          this.info = { ...this.info, ...res.data };
        })
        .catch(() => {
          this.isloading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.my-info {
  .my-info-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .my-info-item-title {
      width: 100px;
      font-weight: 400;
      font-size: 18px;
      color: #666666;
    }
    .my-info-item-content {
      color: #333333;
      font-weight: 400;
      font-size: 18px;
    }
    .bold {
      color: #333333;
    }
    .Amount {
      font-weight: bold;
      font-size: 20px;
      color: #e12a14;
    }
  }
}
.Amount {
  font-weight: bold;
  font-size: 20px;
  color: #e12a14;
}
.title {
  font-size: 20px;
  color: #333333;
  margin-bottom: 10px;
}

.statusName {
  font-size: 24px;
  color: #1d79ff;
  margin-bottom: 10px;
}
.submit-btn {
  width: 144px;
  height: 52px;
  background: #1d79ff;
  border-radius: 6px;
  font-size: 18px;
  color: #ffffff;
}
</style>
